import { useStaticQuery, graphql } from "gatsby"

export const usePartenaires = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allDirectLinkEntityDirectLinkEntity(
          sort: { fields: field_weight, order: DESC }
          filter: {
            relationships: { direct_link_type: { name: { eq: "partenaire" } } }
            highlight: { eq: true }
          }
        ) {
          ...AllPartenaires
        }
        taxonomyTermTypeDeLienDirect(name: { eq: "partenaire" }) {
          ...AllPartenairesTaxo
        }
      }
    `
  )
  return data
}

export const queryPartenaires = graphql`
  fragment AllPartenaires on direct_link_entity__direct_link_entityConnection {
    edges {
      node {
        drupal_internal__id
        name
        drupal_id
        url {
          uri
        }
        image_direct_link {
          alt
        }
        relationships {
          image_direct_link {
            localFile {
              extension
              SlugifiedPublicUrl
            }
          }
        }
      }
    }
  }
`

export const queryTaxo = graphql`
  fragment AllPartenairesTaxo on taxonomy_term__type_de_lien_direct {
    drupal_internal__tid
    field_label
    description {
      processed
    }
  }
`
